import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

const KEY = ["classrooms"];

// GET /api/v1/classrooms/ (opcional ?headquarters=<id>) → aulas de la academia.
function useClassrooms(headquartersId) {
  return useQuery({
    queryKey: headquartersId ? [...KEY, { hq: headquartersId }] : KEY,
    queryFn: () => {
      const url = headquartersId
        ? `/api/v1/classrooms/?headquarters=${headquartersId}`
        : "/api/v1/classrooms/";
      return apiClient.get(url).then((r) => r.data);
    },
  });
}

function useCreateClassroom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) =>
      apiClient.post("/api/v1/classrooms/", body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

function useUpdateClassroom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) =>
      apiClient.patch(`/api/v1/classrooms/${id}/`, body).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

function useDeleteClassroom() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiClient.delete(`/api/v1/classrooms/${id}/`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export {
  useClassrooms,
  useCreateClassroom,
  useUpdateClassroom,
  useDeleteClassroom,
  KEY,
};
